import type { MonthDay } from "../types";

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const MONTH_OPTIONS: Array<{ value: number; label: string }> =
  MONTH_NAMES.map((label, i) => ({ value: i + 1, label }));

export function isValidMonthDay(md: MonthDay | null | undefined): md is MonthDay {
  if (!md) return false;
  if (!Number.isInteger(md.month) || md.month < 1 || md.month > 12) return false;
  if (!Number.isInteger(md.day) || md.day < 1 || md.day > daysInMonth(md.month)) return false;
  return true;
}

// Days in a given month. Uses year 2000 (leap year) so Feb gets 29.
export function daysInMonth(month: number): number {
  if (month < 1 || month > 12) return 31;
  return new Date(2000, month, 0).getDate();
}

export function parseMonthDay(input: string | null | undefined): MonthDay | null {
  if (!input) return null;
  const parts = input.split("-");
  if (parts.length !== 2) return null;
  const month = parseInt(parts[0], 10);
  const day = parseInt(parts[1], 10);
  const md = { month, day };
  return isValidMonthDay(md) ? md : null;
}

export function formatMonthDay(md: MonthDay | null | undefined): string {
  if (!isValidMonthDay(md)) return "";
  return `${String(md.month).padStart(2, "0")}-${String(md.day).padStart(2, "0")}`;
}

// -1 | 0 | 1 — month then day order
export function compareMonthDay(a: MonthDay, b: MonthDay): number {
  if (a.month !== b.month) return a.month < b.month ? -1 : 1;
  if (a.day !== b.day) return a.day < b.day ? -1 : 1;
  return 0;
}

// Convert a Date to MonthDay (UTC).
export function dateToMonthDay(date: Date): MonthDay {
  return { month: date.getUTCMonth() + 1, day: date.getUTCDate() };
}
